import {
    NAV_PATH_HOME,
    NAV_PATH_JOBS,
    NAV_PATH_EDUCATION,
    NAV_PATH_SKILLS,
    NAV_PATH_PORTFOLIO
} from '@/shared/constants';

export default [
    {
        path: NAV_PATH_HOME,
        label: 'Home'
    },
    {
        path: NAV_PATH_JOBS,
        label: 'Jobs'
    },
    {
        path: NAV_PATH_EDUCATION,
        label: 'Education'
    },
    {
        path: NAV_PATH_SKILLS,
        label: 'Skills'
    },
    {
        path: NAV_PATH_PORTFOLIO,
        label: 'Portfolio'
    }
];


// WEBPACK FOOTER //
// ./app/assets/js/shared/routes.js